import { string } from 'yup'

const cssLengthUnitRegex =
  /^-?\d*\.?\d+(px|em|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|%)$/i

export const cssLengthUnitSchema = string().matches(cssLengthUnitRegex)
